import gql from "graphql-tag";

export const REMOVE_COACH_FROM_CHILD = gql`
  mutation RemoveCoachesFromChild($coachUuid: ID!, $clientUuid: ID!) {
    removeCoachesFromChild(coachUuid: $coachUuid, clientUuid: $clientUuid) {
      returnMessage {
        status
        message
      }
      child {
        id
        name
      }
    }
  }
`;
